import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import { Button, Typography } from '@maistodos/design-system-web'

import { Content } from '@/components/Content'
import { isLanguageSupported } from '@/shared/utils/format-locale'

type ErrorFallbackProps = {
  error?: Error
  resetErrorBoundary?: () => void
  locale_code?: string
}

export const ErrorFallback = ({
  resetErrorBoundary,
  locale_code,
}: ErrorFallbackProps) => {
  const { t, i18n } = useTranslation()

  useEffect(() => {
    i18n.changeLanguage(isLanguageSupported(locale_code) ?? 'pt_BR')
  }, [locale_code, i18n])

  return (
    <Content title={t('Ocorreu um erro inesperado')}>
      <div className="flex flex-col gap-spacing16">
        <Typography variant="medium" color="neutral600">
          {t(
            'Desculpe pelo inconveniente. Ocorreu um erro inesperado durante o processamento. Nossa equipe técnica já foi notificada.',
          )}
        </Typography>
        <Typography variant="medium" color="neutral600">
          {t(
            'Você pode tentar novamente mais tarde ou entrar em contato com nosso suporte caso o problema persista.',
          )}
        </Typography>
        {resetErrorBoundary && (
          <div className="mt-spacing16">
            <Button onClick={resetErrorBoundary} fullWidth>
              {t('Tentar novamente')}
            </Button>
          </div>
        )}
      </div>
    </Content>
  )
}
